<!--
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-01-08 16:55:33 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-07-09 15:07:36 +0800
 * @FilePath     : /ai-agent-lumina/src/components/global/button/src/izt-button.vue
 * @Description  : 按钮
 *
 * 自定义样式： className
 *
 * 按钮类型 type
  - default: 默认按钮
  - primary: 主要按钮
  - white: 白底按钮
  - danger: 警告按钮
 * 按钮尺寸 size
  - small: 小尺寸
  - medium: 中尺寸 (默认)
  - large: 大尺寸 暂未维护
 * 按钮前置图标 prefix-icon
  - iconfont的name
 * 按钮后置图标 suffix-icon
  - iconfont的name
 * 按钮禁用 disabled
  - false 默认false
  - true
-->
<style lang="scss" scoped>
.izt-button {
  all: unset;

  height: 58px;
  min-width: 126px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 24px;
  box-sizing: border-box;
  border-radius: 58px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 26px;
  transition: all 0.2s ease;
  user-select: none;

  // 加载状态
  .loading {
    display: flex;
    align-items: center;
    .loading-text {
      margin-left: 8px;
    }
  }
  /* 图标 */
  .prefix, .suffix {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    [class*="icon-"] {
      font-size: 26px !important;
      display: inline-flex;
      align-items: center;
    }
  }
  .prefix {
    margin-right: 8px;
  }
  .suffix {
    margin-left: 8px;
  }

  &:active:not(.disabled) {
    transform: translateY(1px);
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  /* 类型 */
  &.default {
    --van-loading-spinner-color: var(--izt-button-color-65);
    border: 2px solid var(--izt-button-color);
    color: var(--izt-button-color);
    .loading-text {
      color: var(--izt-button-color-65);
    }
  }
  &.primary {
    --van-loading-spinner-color: var(--izt-button-text-color-85);
    background-color: var(--izt-button-color);
    color: var(--izt-button-text-color-85);
    .loading-text {
      color: var(--izt-button-text-color-85);
    }
  }
  &.danger {
    --van-loading-spinner-color: rgba(255, 67, 67, 1);
    background-color: #FFFFFF;
    color: rgba(255, 67, 67, 1);
    .loading-text {
      color: rgba(255, 67, 67, 1);
    }
  }
  &.white {
    --van-loading-spinner-color: var(--izt-button-color-65);
    background-color: #fff;
    color: var(--izt-button-color-65);
    .loading-text {
      color: var(--izt-button-color-65);
    }
  }
  // 非透明按钮需要设置阴影
  &:not(.default) {
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.15);
  }

  /* 尺寸 */
  &.small { // 小尺寸
    height: 42px;
    min-width: 100px;
    border-radius: 42px;
    font-size: 26px;
    padding: 0 24px;
  }
  // TODO 大尺寸按钮  暂无需求
  &.large { // 大尺寸
    height: 72px;
    border-radius: 72px;
    font-size: 32px;
    padding: 0 30px;
  }
}
</style>

<template>
  <button :class="['izt-button', type, size, { disabled: disabled || loading }, className]" :disabled="disabled || loading">
    <template v-if="!loading">
      <!-- 前置图标 -->
      <div class="prefix" v-if="prefixIcon">
        <izt-icon :class-name="prefixIcon"></izt-icon>
      </div>

      <!-- 文本内容 -->
      <span v-if="$slots.default" class="izt-button__content">
        <slot />
      </span>

      <!-- 后置图标 -->
      <div class="suffix" v-if="suffixIcon">
        <izt-icon :class-name="suffixIcon" ></izt-icon>
      </div>
    </template>
    <template v-else>
      <div class="loading">
        <van-loading :size="loadingSize[size]"/>
        <span class="loading-text">{{loadingText}}</span>
      </div>
    </template>
  </button>
</template>

<script setup name="izt-button">
  defineOptions({ name: 'izt-button' });

  const props = defineProps({
    className: { type: String, default: '' },
    type: {
      type: String,
      /**
       * default (透明背景 | 配置边框与文字颜色) 默认按钮
       * primary (配置背景，文字白色) 主要按钮
       * white (白色背景 | 文字颜色取按钮色)
       * danger (白色背景 | 红色文字) 危险按钮
       */
      default: 'default'
    },
    size: {
      type: String,
      default: 'medium' // small(小) | medium(正常) | large(大 暂时没用到)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prefixIcon: {
      type: String,
      default: null
    },
    suffixIcon: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: '提交中...'
    }
  });

  // 样式枚举
  const loadingSize = {
    small: '0.3rem',
    medium: '0.45rem',
    large: '0.6rem'
  }
</script>